<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Journal Entry</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" to="/new-journal" class="mt-2">
            <v-icon left dark>mdi-plus</v-icon>New Journal Entry
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="200"
              :mobile-breakpoint="0"
              :search="search"
              :headers="headers"
              :items="journalData"
            >
              <!-- Credit template -->
              <template v-slot:item.credit="{ item }">
                <span v-if="item.credit > 0">{{item.credit | currency }}</span>
                <span v-else>-</span>
              </template>
              <!-- end -->

              <!-- Debit template -->
              <template v-slot:item.debit="{ item }">
                <span v-if="item.debit > 0">{{item.debit | currency }}</span>
                <span v-else>-</span>
              </template>
              <!-- end -->

              <!-- Debit template -->
              <template v-slot:item.date="{ item }">
                <span>{{ item.date | date }}</span>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    pageItems: 200,
    journalData: [],
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Account", value: "account.Name" },
      { text: "Remarks", value: "narration" },
      { text: "Debit", value: "debit" },
      { text: "Credit", value: "credit" },
      { text: "DocDate", value: "date" }
    ],
    jdt1: []
  }),
  methods: {
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      const self = this;
      const url = `/manual-journal-entries`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          console.log(res);
          if (res.ResultCode == 1200) {
            self.journalData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getRecords();
  }
};
</script>